import React from 'react';

const About = () => {
  return (
    <div className="rocks">
      <div className="lg:w-1/2 mx-auto px-8">
        <h2>About</h2>
        <p>
        Datapult is a service that was created by TeamZero in the R&amp;D group at ConsensysMesh. We felt that there needed to be an easy way for people to share files and use all the amazing power of decentralized file storage systems (such as IPFS, Filecoin, Arewave, Storj, etc...)
        </p>
      </div>
    </div>

  );
}

export default About
